import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import AccountMain from './AccountMain';
import AccountView from './AccountView';
import { loadRoles } from '../../lib/models/Roles';

class AccountRoot extends PureComponent {
  static propTypes = {
    match: PropTypes.object.isRequired
  };

  state = {
    roles: false
  };

  render() {
    const { match } = this.props;
    const { roles } = this.state;
    if (!roles) {
      return <div>Loading...</div>;
    }
    return (
      <div className="entity-wrapper mt-3">
        <Switch>
          <Route exact path={match.path} component={AccountMain} />
          <Route exact path={`${match.path}/:id`} component={AccountView} />
        </Switch>
      </div>
    );
  }

  componentDidMount() {
    loadRoles()
      .then(roles => this.setState({ roles }))
      .catch(() => {});
  }
}

export default AccountRoot;
